import React, { useEffect } from 'react';
import styled, { useTheme } from 'styled-components';

import Footer from '../containers/Footer';
import { Link } from 'react-router-dom';
import RejectedImg from '../assets/rejected.svg';
import Spacer from '../components/Spacer';
import Button from '../components/Button';
import useFormStore from "../state/useFormStore";
import Lottie from 'lottie-react';
import decline from '../assets/decline.json';
import { clearLocalStorage } from '../utils/utils';

const Wrapper = styled.div`
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 36px;
  padding-bottom: 100px;
`;

const WaitImage = styled.img`
  width: 70%;
  height: auto;
  max-width: 300px;
`;

const MainText = styled.div`
  margin: 30px 0 20px 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.basic2000};
`;

const Subtext = styled.h4`
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.basic2000};
  margin: 0 0 40px 0;
  text-align: center;
  width: 80%;

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;

const ExtraText = styled.h5`
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.basic2000};
  margin: 30px 0 0 0;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  width: 70%;
  margin-top: 20px;

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;


const Rejected = () => {
  const { first_name } = useFormStore(state => ({ first_name: state.first_name }));
  const theme = useTheme();

  useEffect(() => {
    // Limpiar localStorage después de un delay para permitir que MyAccountAccess termine de cargar
    const timer = setTimeout(() => {
      clearLocalStorage();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Wrapper>
 <Lottie animationData={decline} style={{ width:'200px', margin:'-10px' }}/>       
 <MainText>
  {`Lo sentimos, ${first_name}`}
  </MainText>
      <Subtext>En este momento no tenemos un producto para ofrecerte de acuerdo a tu perfil crediticio.</Subtext>
      <ExtraText>
        ¡Pero no todo está perdido!
        <br />
        Puedes volver a intentarlo más tarde.
      </ExtraText>
      <ButtonWrapper>
        <div className='flex justify-center'>
      <Link to={`/`} className=''>
        <button className={`bg-[#fff200] text-black p-2 rounded w-96 py-5 rounded-lg font-bold text-xl`}>Volver al Inicio</button>
        </Link>
        </div>
      </ButtonWrapper>
      {/* <Footer /> */}
    </Wrapper>
  )
};

export default Rejected;
